// Query-string switches for diagnosing the v2 board on a real TV, where there
// is no devtools. Open the display URL with, e.g.
//   ?debug=1      show the on-screen diagnostics overlay (DebugOverlay)
//   ?adsound=0    keep ad videos muted (A/B: does unmuting kill the picture?)
// Read once at load; the display never navigates during normal operation so
// the query survives.
const params = () => {
  try {
    return new URLSearchParams(window.location.search);
  } catch {
    return new URLSearchParams();
  }
};

export const debugOverlayEnabled = () => params().get("debug") === "1";
export const adSoundDisabled = () => params().get("adsound") === "0";
